import * as React from 'react';

import { connect } from 'react-redux';

import { FilterBase, mapDispatchToProps, mapStateToProps } from './filter-base';

export class FilterDropdown extends FilterBase {
    convertEvtToString(evt: React.ChangeEvent<HTMLSelectElement>) {
        return evt.target.value;
    }

    submitChange(evt: React.ChangeEvent<HTMLSelectElement>) {
       // this.updateValue(evt);
        this.boundFilterUpdate(this.convertEvtToString(evt), true);
    }

    renderFormElement() {
        if (this.props.selectedOptions !== "" && this.props.options.length === 0) {
            this.boundFilterUpdate("", true);
        }
        return (
            <div className="adage-form-field-wrapper">
                {
                    this.props.title ? <label htmlFor={this.props.title.replace(/ /g, '')}>{this.props.title}</label> : null
                }
                <select disabled={this.props.IsDisabled} id={this.props.title.replace(/ /g, '')} value={this.props.selectedOptions ? this.props.selectedOptions : ""} onChange={this.submitChange.bind(this)} >
                    {
                        this.props.defaultOption ? <option value={this.props.defaultOption.value}>{this.props.defaultOption.text}</option> : null
                    }
                    {
                        this.props.options.map(option => <option key={`${option.value}~${option.text}`} value={option.value}>{option.text}</option>)
                    }
                </select>
            </div>
        )
    }
}

export const ConnectedFilterDropdown = connect(mapStateToProps, mapDispatchToProps)(FilterDropdown);